<template>
    <!-- :style="{ 'background-color': task.color != '#000000' ? task.color : null } -->
    <div class="np-task" @dblclick="showModTask(task.id, statusId)">
        <div class="np-task-header">
            <div class="np-group">
                <div class="np-badge-xs" :class="task.priorityObj.class">
                    {{ $t(task.priorityObj.label) }}
                </div>
                <IndicatorProgress :progress="task.completion_percent" size="ms-1 np-badge-xs" />
            </div>
            <div class="np-group align-items-center np-overflow-visible">
                <div class="dropdown dropstart">
                    <button class="np-btn np-btn-link np-mr-2" 
                        :id="'taskDropdownMenuLink' + task.id" 
                        role="button" 
                        data-bs-toggle="dropdown" 
                        aria-expanded="false">
                        <svg><use href="@/assets/images/icons/dots-vertical.svg#icon"></use></svg>
                    </button>
                    <ul class="dropdown-menu" :aria-labelledby="'taskDropdownMenuLink' + task.id">
                        <li class="dropdown-item">
                            <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="showModTask(task.id, statusId)">
                                <img src="@/assets/images/dashboard/base-edit-dark.svg" /> {{ $t("UI.task.change") }}
                            </button>
                        </li>
                        <li class="dropdown-item">
                            <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="showMoveTo(task.id)">
                                <img src="@/assets/images/dashboard/base-moveto-dark.svg" /> {{ $t("UI.task.moveTo") }}
                            </button>                                                            
                        </li>
                        <li class="dropdown-item">
                            <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="showArch(3, task.id)">
                                <img src="@/assets/images/dashboard/base-archive-dark.svg" /> {{ $t("UI.task.archive") }}
                            </button>
                        </li>
                        <li class="dropdown-item">
                            <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="showDel(3, task.id)">
                                <img src="@/assets/images/dashboard/base-delete-dark.svg" /> {{ $t("UI.task.delete") }}
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="np-bt p-0" v-if="completedLoading">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div class="np-btn np-btn-link" :class="{'completed' : task.date_actual_end}" @click="this.complete()" v-else>
                    <svg v-if="task.date_actual_end" ><use href="@/assets/images/icons/checked2.svg#icon"></use></svg>
                    <svg v-else><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>
                </div>                 
            </div>
        </div>
        <div class="np-task-body">
            <div class="np-task-cover np-mb-3" v-if="task?.imageFile" :style="{'background-image': 'url(' + Config.SERVER + 'web/' + task.imageFile + ')'}"></div>                
            <h6 class="np-task-title np-mb-3" :class="{'completed' : task.date_actual_end}">{{ task.title }}</h6>
            <div class="cobalt-task__desc np-mb-3" :class="{'completed' : task.date_actual_end}">{{ description }}</div>

            <div class="np-group align-items-center mb-3" v-if="task.date_planned_end > 0">
                <IndicatorDaysTo :dateStart="task.date_planned_start" :dateEnd="task.date_planned_end" classes="np-transparent np-borderless me-2"/>                
  
                <ProgressBar 
                    :min="task.date_planned_start" 
                    :max="task.date_planned_end" 
                    :current="new Date().getTime() / 1000"             
                    classes="np-progressbar-sm flex-grow-1"
                />
            </div>
        </div>
        <!-- <div class="card-task__card-progress">
            <div class="card-task__card-progressbar" :class="deadlineColor" :style="{ 'width': progress }"></div>
        </div> -->
        <div class="np-task-footer">
            <div class="np-group">
                <div class="me-2" v-if="task.performer != ''">
                    <CobaltProfilesList :users="task.performer" size="np-avatar-small" />
                </div>
                <div class="np-group align-items-center" v-if="task.comments.length > 0">
                    <svg class="np-mr-1"><use href="@/assets/images/icons/comment.svg#icon"></use></svg>
                    <span class="np-font-s np-lh-s">{{ (task.comments.length).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) }}</span>
                </div>
            </div>
            <div class="np-group">
                <div class="np-group align-items-center me-2" v-if="this.filesCount > 0">
                    <svg class="np-mr-1"><use href="@/assets/images/icons/folder2.svg#icon"></use></svg>
                    <span class="np-font-s np-lh-s">{{ (this.filesCount).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}) }}</span>
                </div>                                    
                <div class="np-group align-items-center" v-if="task.subtask.length > 0">
                    <svg class="me-1"><use href="@/assets/images/icons/folder-tree.svg#icon"></use></svg>
                    <span class="np-font-s np-lh-s">{{ this.completedSubtask }}/{{ task.subtask.length }}</span>
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { localeDate, lightenDarkenColor, priorityValues } from '@/utils/format'
import CobaltProfilesList from "@/components/dashboard/parts/CobaltProfilesList.vue"
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import ProgressBar  from "@/components/elements/ProgressBar.vue" 
import { nameColor, cleanHtmlText } from '@/utils/format'
import Config from '../config.js'
import IndicatorProgress from './elements/IndicatorProgress.vue'

export default {
    components: {
        CobaltProfilesList,
        IndicatorDaysTo,
        ProgressBar,
        IndicatorProgress
    },
    name: 'TaskCard',
    props: {
        task: {
            type: Object,
            required: true
        },
        statusId: {
            type: Number,
            required: true
        },
        statuses: {
            type: Array,
            required: true
        }
    },
    computed: {
        deadlineColor: {
            get() {
                if (this.task.date_actual_end) {
                    return ''
                }
                const start = this.task.date_planned_start
                const end   = this.task.date_planned_end
                const section = ( end - start ) / 3
                const current =  new Date().getTime() / 1000

                if (current > end) {
                    return 'np-color-danger';
                }
                if (current < start + section) {
                    return 'np-color-success'
                }

                if (start > 0 && end > 0) {                    
                    if (start + section < current && current < end - section) {
                        return 'level-1'
                    }
                    if (end - section < current && current < end) {
                        return 'level-2'
                    }                                        
                }
                return ''
            }
        },
        filesCount: {
            get() {
                let count = this.task.files.length
                this.task.subtask.forEach(subTask => {
                    if (subTask.files.length > 0) {
                        count += subTask.files.length
                    }
                })  
                return count
            }
        },
        progress: {
            get() {
                const start = this.task.date_planned_start
                const end   = this.task.date_planned_end

                if (start > 0 && end > 0) {
                    const current = new Date().getTime() / 1000
                    const first = current > start ? current : start

                    const progress = ( end - first ) * 100 / ( end - start )

                    return parseInt( progress ) + '%'
                }

                return '100%'
            }            
        },
        completedSubtask: {
            get() {
                let res = 0
                this.task.subtask.forEach(subTask => {
                    if (!!subTask.date_actual_end) {
                        res++
                    }
                })
                return res
            }
        },
        description() {
            return cleanHtmlText(this.task.description, {
                
            })
        }      
    },
    data() {
        return {
            Config,
            overlap: false,
            completedLoading: false,
            priorityValues
        }
    },
    methods: {
        ...mapActions('board', ['completeTask']),
        localeDate,
        lightenDarkenColor,
        nameColor,
        switchDropdown() {
            this.overlap = !this.overlap
        },
        showModTask(taskId, statusId) {
            this.$emit('showModTask', taskId, statusId);
        },
        showArch(type, id) {
            this.$emit('showArch', type, id);
        },        
        showDel(type, id) {
            this.$emit('showDel', type, id);
        },
        showMoveTo(id) {
            this.$emit('showMoveTo', id);
        },
        async complete() {
            let isComplete = !!!this.task.date_actual_end

            await this.completeTask( { complete: isComplete, id: this.task.id } )          

            await this.$emit('refresh')
        },                
    }
}
</script>